// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadGallery_root__8c2WE","isDraggable":"UploadGallery_isDraggable__2acug","loading-images":"UploadGallery_loading-images__1Risz"};